import { render, staticRenderFns } from "./MobileMenuSection.vue?vue&type=template&id=71c2bbdb&scoped=true&"
import script from "./MobileMenuSection.vue?vue&type=script&lang=js&"
export * from "./MobileMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuSection.vue?vue&type=style&index=0&id=71c2bbdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2bbdb",
  null
  
)

export default component.exports